"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _arity;

function _arity(a, b) {
  switch (a) {
    case 0:
      return function () {
        return b.apply(this, arguments);
      };

    case 1:
      return function () {
        return b.apply(this, arguments);
      };

    case 2:
      return function () {
        return b.apply(this, arguments);
      };

    case 3:
      return function () {
        return b.apply(this, arguments);
      };

    case 4:
      return function () {
        return b.apply(this, arguments);
      };

    case 5:
      return function () {
        return b.apply(this, arguments);
      };

    case 6:
      return function () {
        return b.apply(this, arguments);
      };

    case 7:
      return function () {
        return b.apply(this, arguments);
      };

    case 8:
      return function () {
        return b.apply(this, arguments);
      };

    case 9:
      return function () {
        return b.apply(this, arguments);
      };

    case 10:
      return function () {
        return b.apply(this, arguments);
      };

    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}